import API_SERVICE from "src/utils/axios";

const APPLYCOUPONURL=`/v4/coupon/apply-coupon`;

export const applyCouponCode = (couponCode,entityId) => {
    return API_SERVICE.post(APPLYCOUPONURL, {couponCode,entityId});
  };